import type { AppointmentsListParams } from '@/admin/api/appointments';
import { appointmentsApi } from '@/admin/api/appointments';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export type { AppointmentsListParams };

export const appointmentsQuery = (params?: AppointmentsListParams) =>
	queryOptions({
		queryKey: ['session-bookings', params ?? {}] as const,
		queryFn: () => appointmentsApi.list(params),
		placeholderData: keepPreviousData,
		staleTime: 30_000,
	});
